import React from 'react';
import T from 'prop-types';

import { MenuItem } from '@szhsin/react-menu';
import { CustomLabelSwitch } from './CustomLabel';

const ShowOnlySelected = ({
  checked,
  disabled,
  onClick,
}) => (
  <MenuItem
    type="checkbox"
    checked={checked}
    disabled={disabled}
    onClick={onClick}
  >
    <CustomLabelSwitch
      id="show-only-selected"
      checked={checked}
      disabled={disabled}
      labelText="Show Only Selected"
    />
  </MenuItem>
);

ShowOnlySelected.propTypes = {
  checked: T.bool.isRequired,
  disabled: T.bool,
  onClick: T.func.isRequired,
};

export default ShowOnlySelected;
